import {HttpClient} from "../../service/httpClient/HttpClient";

export class TagService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getTagList(fundID, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/tags`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getAllTags(fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/tags/offers`
            ).then(resolve).catch(reject)
        })
    }


    addNewTag(fundID, name) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/tags`,
                {
                    name
                }
            ).then(resolve).catch(reject)
        })
    }

    updateTag(fundID, tagId, name) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/tags/${tagId}`,
                {
                    name
                }
            ).then(resolve).catch(reject)
        })
    }

    getTagDetail(fundID, tagId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/tags/${tagId}`
            ).then(resolve).catch(reject)
        })
    }

    getTagOffers(limit, name) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `tags/offers`,
                {
                    name, limit,
                    page: 0,
                    size: 5
                }
            ).then(resolve).catch(reject)
        })
    }
}